import { log } from "../../utils";
import { ChatServerAsyncActionType } from "../../utils/useChatServerDispatch";
import { writeMessage } from "./writeMessage";

export default function executeAction(
    text: string,
    meta?: { token?: string; action?: string; ui?: string }
): ChatServerAsyncActionType {
    return (chatServer) => (dispatch, getState) => {
        // add in attributes from meta

        let attributes = getState().attributes;
        attributes = { ...attributes, currentUrl: window.location.href };

        const { token, ...rest } = meta || {};

        attributes = { ...attributes, ...rest };

        chatServer.sendChatMsg({ text, token, attributes }, (err?: Error) => {
            if (err) {
                log("Error sending message", err);
                return;
            }
        });

        const visitor = getState().visitor;
        dispatch(
            writeMessage(
                {
                    text: !token ? text : `${text} (from the list)`,
                },
                visitor
            )
        );
    };
}
